import { defineMessages, type IntlShape } from 'react-intl';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import type { JSONSchema } from '@plone/types';
import iconSVGs from '@redturtle/qubicaamf-theme/helpers/ctaIconsHelper';

export interface CtaBlockExtender {
  // TODO fix any
  linkHref?: any;
  linkTitle: string;
  ctaButtonStyle: 'button' | 'simple' | 'big_button';
  linkIcon?: string;
  cta_color?: 'white' | 'black';
}

const iconChoices = iconSVGs.map((el) => [el.icon, el.name]);

export const addCtaFieldset = ({
  schema,
  intl,
}: {
  schema: JSONSchema;
  intl: IntlShape;
}): JSONSchema => {
  if (isEmpty(find(schema.fieldsets, { id: 'cta' }))) {
    schema.fieldsets.push({
      id: 'cta',
      title: intl.formatMessage(messages.cta_fieldset_title),
      fields: [
        'linkHref',
        'linkTitle',
        'ctaButtonStyle',
        'cta_color',
        'linkIcon',
      ],
    });

    // @ts-ignore
    schema.properties.linkHref = {
      title: intl.formatMessage(messages.LinkTo),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['Title', 'Description'],
      allowExternals: true,
    };

    // @ts-ignore
    schema.properties.linkTitle = {
      title: intl.formatMessage(messages.LinkTitle),
      default: '',
    };

    // @ts-ignore
    schema.properties.ctaButtonStyle = {
      title: intl.formatMessage(messages.cta_style_title),
      widget: 'select',
      choices: [
        ['simple', intl.formatMessage(messages.cta_style_simple)],
        ['button', intl.formatMessage(messages.cta_style_button)],
        ['big_button', intl.formatMessage(messages.cta_style_big_button)],
      ],
      default: 'simple',
      isClearable: false,
    };

    // @ts-ignore
    schema.properties['cta_color'] = {
      title: intl.formatMessage(messages.cta_color_style),
      widget: 'color_picker',
      colors: [
        {
          name: 'white',
          label: intl.formatMessage(messages.cta_color_white),
        },
        {
          name: 'black',
          label: intl.formatMessage(messages.cta_color_black),
        },
      ],
      default: 'black',
    };

    // @ts-ignore
    schema.properties.linkIcon = {
      title: intl.formatMessage(messages.cta_style_icon_select),
      widget: 'select',
      choices: iconChoices,
      default: '',
    };
  }

  return schema;
};

const messages = defineMessages({
  cta_fieldset_title: {
    id: 'redturtle__volto-blocks__cta_fieldset_title',
    defaultMessage: 'Call to action',
  },
  // copied from core listing block
  LinkTitle: {
    id: 'Link title',
    defaultMessage: 'Link Title',
  },
  // copied from core listing block
  LinkTo: {
    id: 'Link to',
    defaultMessage: 'Link to',
  },
  // cta_title_default: {
  //   id: 'redturtle__volto-blocks__cta_title_default',
  //   defaultMessage: 'Read more',
  // },
  cta_style_title: {
    id: 'redturtle__volto-blocks__cta_style_title',
    defaultMessage: 'Select CTA style',
  },
  cta_style_simple: {
    id: 'redturtle__volto-blocks__cta_style_simple',
    defaultMessage: 'Simple',
  },
  cta_style_button: {
    id: 'redturtle__volto-blocks__cta_style_button',
    defaultMessage: 'Button',
  },
  cta_style_big_button: {
    id: 'redturtle__volto-blocks__cta_style_big_button',
    defaultMessage: 'Big button',
  },
  cta_color_style: {
    id: 'redturtle__volto-blocks__cta_color_style',
    defaultMessage: 'Select the CTA color',
  },
  cta_style_icon_select: {
    id: 'redturtle__volto-blocks__cta_style_icon_select',
    defaultMessage: 'Select the CTA icon',
  },
  cta_color_white: {
    id: 'redturtle__volto-blocks__cta_color_white',
    defaultMessage: 'White',
  },
  cta_color_black: {
    id: 'redturtle__volto-blocks__cta_color_black',
    defaultMessage: 'Black',
  },
});
